
import Vue from 'vue';
import { EventBus } from '@/plugins/eventBus';
import { Trustev } from '@/plugins/trustev';
import { OTPStatus, KBAStatus, HelperDeliveryType } from '@/plugins/trustevAuthentication';
import { GeneralAuthentication, IQuestionsItem } from '@/plugins/digitalVerification';
// import { SnackMessage } from '@/plugins/utils';
import { BreakCamel } from '@/plugins/utilities';
import { LogIt } from '@/plugins/webApi';

export default Vue.extend({
  data: () => ({
    langs: [
        'English',
        'Spanish',
    ],
    verifyOTP: 123456,
    otpStatus: -1,
    checkOTP: false,
    mobilePhone: 0,
    verified: false,
    otp: false,
    kba: false,
  }),
  components: {
  },
  props: {
    auths: {
      type: Array,
    },
  },
  methods: {
      getStatus(a: GeneralAuthentication): string {
          if (a.Questions === undefined) {
            return `${BreakCamel(OTPStatus[a.Status])} via ${HelperDeliveryType[a.DeliveryType || 0]} ${this.getLanguage(a)}`;
          } else {
            return `${BreakCamel(KBAStatus[a.Status])} with ${(a.Questions as IQuestionsItem[]).length} Questions`;
          }
      },
      getLanguage(a: GeneralAuthentication): string {
          if (a.Language !== undefined) {
              return `in ${this.langs[a.Language]}`;
          } else {
              return 'in English';
          }
      },
      check(): void {
          this.otp = OTPStatus[(this.auths[1] as any).Status] === 'Offered';
          this.kba = KBAStatus[(this.auths[0] as any).Status] === 'Offered';
      },
      getCase(): string {
          return (this.auths[0] as GeneralAuthentication).url.replace('https://app.trustev.com/api/v2.0/case/', '').replace('/authentication/otp', '').replace('/authentication/kba', '');
      },
      genOTP(): void {
          const otp = new Trustev({
              name: 'gen_otp',
              data: {
                  case: this.getCase(),
                  status: 0,
              },
          });
          otp.Send()
          .then((resp) => {
              EventBus.$emit('message', { context: 'info', text: `OTP Status has changed to ${BreakCamel(OTPStatus[resp.data.Status])}` });
              this.verified = true;
          })
          .catch((err) => {
              EventBus.$emit('message', { context: 'error', text: `${err}` });
              LogIt(`(Components/VisionAuth.vue)->genOTP() ${err}`, true);
          });
      },
      verOTP(): void {
          const otp = new Trustev({
              name: 'verify_otp',
              data: {
                  case: this.getCase(),
                  id: this.verifyOTP,
              },
          });
          this.checkOTP = true;
          otp.Send()
          .then((resp) => {
              this.otpStatus = resp.data.Status;
              EventBus.$emit('message', { context: 'info', text: `OTP Status has changed to ${OTPStatus[resp.data.Status]}` });
              this.checkOTP = false;
              LogIt(`(Components/VisionAuth.vue)->verOTP() OTP was verified with result [IDV] [OTP] ${OTPStatus[resp.data.Status]}`, false);
          })
          .catch((err) => {
              EventBus.$emit('message', { context: 'error', text: `${err}` });
              LogIt(`(Components/VisionAuth.vue)->verOTP() [IDV] [OTP] ${err}`, false);
          });
      },
  },
  mounted() {
      this.mobilePhone = (this.auths[0] as any).phone;
      this.check();
  },
});
